export default __webpack_public_path__ + "static/media/sandwich.853dd249.svg";